import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

// Config
import { Config } from '../../providers/config/config';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json; charset=UTF-8;'
  })
}

@Injectable()
export class ProvidersService {
  data: any;

  constructor( 
    public http: HttpClient
  ) {
  }

  getProviders( status = null )
  {
    let statusQuery = '';
    if ( status !== null )
    {
      statusQuery = '?status=' + status;
    }
    return this.http.get( Config.API_ROOT_RAPID + 'providers' + statusQuery )
      .pipe( map(this.processData, this) );
  }

  getProvider( providerId )
  {
    return this.http.get( Config.API_ROOT_RAPID + 'providers/' + providerId );
  }

  searchProviders( search_term )
  {
    return this.http.get( Config.API_ROOT_RAPID + 'providers?search=' + search_term )
      .pipe( map(this.processData, this) );
  }

  saveProvider( provider )
  {
    if ( provider.provider_id > 0 )
    {
      return this.http.put( Config.API_ROOT_RAPID + 'providers/' + provider.provider_id, JSON.stringify(provider), httpOptions );
    } else {
      return this.http.post( Config.API_ROOT_RAPID + 'providers', JSON.stringify(provider), httpOptions );
    }
  }

  // Get secure request posted through provider portal.
  // Currently, this is only used for certified hours.
  getSecureDataRequest( requestId )
  {
    return this.http.get( Config.API_ROOT_RAPID + 'portal-secure-requests/' + requestId );
  }

  processData(data: any) 
  {
    this.data = data;
    // Do any mungy stuff here...
    return this.data;
  } 
}  


// WEBPACK FOOTER //
// ./src/providers/providers/providers-service.ts